import { render, staticRenderFns } from "./HowToUseRamiLeviVoucherExplanation.vue?vue&type=template&id=1394cdae&scoped=true"
import script from "./HowToUseRamiLeviVoucherExplanation.vue?vue&type=script&lang=js"
export * from "./HowToUseRamiLeviVoucherExplanation.vue?vue&type=script&lang=js"
import style0 from "./HowToUseRamiLeviVoucherExplanation.vue?vue&type=style&index=0&id=1394cdae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1394cdae",
  null
  
)

export default component.exports